import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { GameAttemptResult, GameAttemptSubmission, LessonGamePlay, PlayItem } from 'src/app/models/module/lessongame.model';
import { ClassmanagementService } from 'src/app/services/classmanagement.service';

@Component({
  selector: 'app-sequence-game',
  templateUrl: './sequence-game.component.html',
  styleUrls: ['./sequence-game.component.css']
})
export class SequenceGameComponent implements OnChanges {
  @Input() game: LessonGamePlay;
  @Output() attempted = new EventEmitter<GameAttemptResult>();

  order: PlayItem[] = [];
  itemState: { [id: number]: 'unattempted' | 'correct' | 'incorrect' } = {};
  checking = false;
  result: GameAttemptResult = null;

  constructor(private classmanager: ClassmanagementService) { }

  ngOnChanges(): void {
    this.reset();
  }

  reset(): void {
    this.result = null;
    this.order = [...(this.game?.steps || [])];
    this.itemState = {};
  }

  drop(event: CdkDragDrop<PlayItem[]>): void {
    if (this.result) { return; }
    moveItemInArray(this.order, event.previousIndex, event.currentIndex);
  }

  checkOrder(): void {
    if (this.checking) { return; }
    this.checking = true;
    const submission = new GameAttemptSubmission();
    submission.gameId = this.game.id;
    submission.orderedStepIds = this.order.map(o => o.id);

    this.classmanager.submitGameAttempt(submission).subscribe(
      (result: GameAttemptResult) => {
        this.result = result;
        this.order.forEach((item, i) => {
          this.itemState[item.id] = (result.correctOrder[i] === item.text) ? 'correct' : 'incorrect';
        });
        this.checking = false;
        this.attempted.emit(result);
      },
      () => { this.checking = false; }
    );
  }

  tryAgain(): void {
    this.reset();
  }
}
